import forgeIcon from "@loot-os/icons/icons/forge";
import { EmptyState } from "../../../../core/EmptyState.js";
import { Skeleton } from "../../../../core/Skeleton.js";
import { ActionButton } from "../../../shared/ActionButton.js";
import { LoadError } from "../../../shared/LoadError.js";
import type { ForgeNoticeContent } from "../../forgeContent.js";

/**
 * In the builder's place while it can't be used: its shape while it loads, why it didn't load, or
 * what stands in the way (no username yet, a box that isn't the shopper's) and the way forward.
 */
export function ForgeNotice(notice: ForgeNoticeContent) {
  if (notice.status === "loading") {
    return (
      <div aria-busy className="grid gap-5 lg:grid-cols-[minmax(0,1fr)_minmax(0,26rem)]">
        <Skeleton className="h-96 rounded-2xl" />
        <Skeleton className="h-64 rounded-2xl max-lg:hidden" />
      </div>
    );
  }
  if (notice.status === "error") return <LoadError message={notice.message} />;
  return (
    <EmptyState
      icon={forgeIcon}
      title={notice.message}
      action={
        notice.action && (
          <ActionButton
            action={notice.action}
            variant={notice.action.href === undefined ? "primary" : "secondary"}
          />
        )
      }
    />
  );
}
